"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
require("core-js/modules/es.array.map.js");
var _utils = require("../utils");
var _icon = _interopRequireDefault(require("../icon"));
var _use = (0, _utils.use)('simple-dropdown'),
  sfc = _use[0],
  bem = _use[1];
var _default = sfc({
  props: {
    useTouch: {
      type: Boolean,
      default: false
    },
    list: Array,
    nameKey: {
      type: String,
      default: 'name'
    },
    contentKey: {
      type: String,
      default: 'content'
    },
    showIcon: {
      type: Boolean,
      default: true
    },
    textAlign: {
      type: String,
      default: 'left'
    }
  },
  data: function data() {
    return {
      show: false
    };
  },
  methods: {
    handleClose: function handleClose(e) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      this.show = !this.show;
      this.$emit('showStatus', this.show);
    },
    handleClick: function handleClick(index) {
      this.$emit('click', index);
    },
    triggerClose: function triggerClose() {
      this.show = false;
    },
    getShowStatus: function getShowStatus() {
      return this.show;
    }
  },
  render: function render(h) {
    var _this = this;
    return h("div", {
      "class": bem(),
      "on": {
        "click": function click(e) {
          return !_this.useTouch && _this.handleClose(e);
        },
        "touchstart": function touchstart(e) {
          return _this.useTouch && _this.handleClose(e);
        }
      }
    }, [h("div", {
      "class": bem('trigger')
    }, [this.slots()]), h("transition", {
      "attrs": {
        "name": "z-dropdown"
      }
    }, [h("div", {
      "class": bem('popover'),
      "directives": [{
        name: "show",
        value: this.show
      }]
    }, [h("ul", {
      "class": bem('menu')
    }, [this.list.map(function (item, index) {
      return h("li", {
        "class": bem('item'),
        "on": {
          "click": function click(e) {
            return !_this.useTouch && _this.handleClick(index);
          },
          "touchstart": function touchstart(e) {
            return _this.useTouch && _this.handleClick(index);
          }
        }
      }, [_this.showIcon && h("div", {
        "class": bem('icon')
      }, [item.classprefix ? h(_icon.default, {
        "attrs": {
          "class-prefix": item.classprefix,
          "name": item[_this.nameKey]
        }
      }) : h(_icon.default, {
        "attrs": {
          "name": item[_this.nameKey]
        }
      })]), h("div", {
        "style": {
          textAlign: _this.textAlign
        },
        "class": [bem('content'), 'z-hairline--bottom']
      }, [item[_this.contentKey]])]);
    })]), h("i", {
      "class": bem('tip-angle')
    })])])]);
  }
});
exports.default = _default;